"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _alloyReactFormField = _interopRequireDefault(require("@adsk/alloy-react-form-field"));
var _alloyReactTextInput = _interopRequireDefault(require("@adsk/alloy-react-text-input"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TextField = _ref => {
  let {
    label,
    initialValue = '',
    onChange,
    caption
  } = _ref;
  (0, _react.useEffect)(() => {
    if (initialValue) {
      onChange({
        enabled: true,
        value: initialValue
      });
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(StyledFormField, {
    label: label,
    labelVariant: _alloyReactFormField.default.LABEL_VARIANTS.TOP
  }, /*#__PURE__*/_react.default.createElement(_shared.Caption, {
    captionValues: caption
  }, /*#__PURE__*/_react.default.createElement(StyledTextInput, {
    onChange: _ref2 => {
      let {
        target: {
          value
        }
      } = _ref2;
      return onChange({
        enabled: true,
        value
      });
    },
    defaultValue: initialValue
  })));
};
const StyledTextInput = (0, _styledComponents.default)(_alloyReactTextInput.default)`
  input {
    box-sizing: border-box;
  }
`;
const StyledFormField = (0, _styledComponents.default)(_alloyReactFormField.default)`
  margin-top: 10px;

  & > label {
    ${{
  ..._alloyReactTheme.default.typography.labelMedium
}}
    color: black;
  }

  & [class^='FormField___StyledDiv'] {
    margin-top: 0;
  }
`;
TextField.propTypes = {
  label: _propTypes.default.string.isRequired,
  initialValue: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  caption: _propTypes.default.object
};
var _default = exports.default = TextField;